import { IconComponent } from '../icon.types';

export const MetaIcon: IconComponent = (props) => (
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_388_583)">
      <path
        d="M3.89108 15.8325C3.89108 17.2147 4.19269 18.2714 4.58692 18.9123C4.797 19.2771 5.09953 19.5796 5.46376 19.789C5.82799 19.9985 6.24095 20.1074 6.66069 20.1047C7.67442 20.1047 8.60179 19.8534 10.389 17.3705C11.8207 15.3814 13.5077 12.5956 14.6441 10.8364L16.5665 7.87099C17.9018 5.81152 19.4449 3.52209 21.2196 1.96524C22.6651 0.703665 24.2257 0 25.7964 0C28.4333 0 30.9451 1.53424 32.8675 4.41173C34.9713 7.56314 35.9963 11.5326 35.9963 15.6289C35.9963 18.0641 35.5182 19.8534 34.7047 21.267C33.92 22.6341 32.3831 24 29.8063 24V20.1047C32.0127 20.1047 32.5596 18.0691 32.5596 15.7395C32.5596 12.4197 31.7887 8.7355 30.0904 6.10304C28.8851 4.23581 27.3233 3.09487 25.6049 3.09487C23.7464 3.09487 22.2508 4.5022 20.5701 7.01152C19.6765 8.34471 18.7591 9.96942 17.7291 11.8027L16.5952 13.8132C14.3175 17.8681 13.7405 18.7916 12.6016 20.3158C10.6092 22.9948 8.90466 24 6.66069 24C3.99871 24 2.31541 22.8427 1.27916 21.0986C0.421868 19.6775 0.00386047 17.8128 0.00386047 15.688L3.89108 15.8325Z"
        fill="currentColor"
      />
      <path
        d="M3.06876 4.68691C4.85092 1.9288 7.42279 0 10.3726 0C12.0809 0 13.7792 0.502618 15.5527 1.96147C17.4925 3.55099 19.5575 6.16838 22.1394 10.4821L23.0643 12.0302C25.297 15.7646 26.5685 17.6846 27.3107 18.5918C28.2668 19.7554 28.9376 20.0997 29.8062 20.0997C32.0126 20.0997 32.5595 18.0641 32.5595 15.7344L35.9887 15.6264C35.9887 18.0616 35.5106 19.8509 34.6971 21.2645C33.9199 22.6341 32.3831 24 29.8062 24C28.2042 24 26.785 23.6507 25.2156 22.1642C24.0092 21.0232 22.5987 18.9964 21.5136 17.1744L18.286 11.7613C16.6665 9.04461 15.181 7.01906 14.3212 6.10681C13.395 5.11539 12.2073 3.92419 10.31 3.92419C8.77443 3.92419 7.47035 5.00607 6.37902 6.66094L3.06876 4.68691Z"
        fill="currentColor"
      />
      <path
        d="M10.3101 3.92419C8.7745 3.92419 7.47042 5.00607 6.3791 6.66094C4.83597 8.99937 3.89108 12.4825 3.89108 15.8325C3.89108 17.2147 4.19269 18.2714 4.58692 18.9123L1.2729 21.0986C0.421868 19.6775 0.00386047 17.8128 0.00386047 15.688C0.00386047 11.8241 1.06014 7.79686 3.06883 4.68691C4.85099 1.9288 7.42286 0 10.3727 0L10.3101 3.92419Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_388_583">
        <rect width="36" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
